import React from 'react'
import { Grid, Typography } from '@mui/material'
import { useRecordContext } from 'react-admin'
import FinancePaid from './FinancePaid'
import FinancePending from './FinancePending'
import FinanceOutstanding from './FinanceOutstanding'
import PropTypes from 'prop-types'

const FinancePayment = ({ sb }) => {
  const record = useRecordContext()

  if (!sb || !record) {
    return null
  }

  return (
    <React.Fragment>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography
            sx={{
              color: '#ED9C23',
              fontWeight: '700',
              letterSpacing: '0.46px',
              marginRight: '5px',
              textTransform: 'uppercase',
            }}
          >
            Finance Payment:
          </Typography>
        </Grid>

        {sb.payments.finance ? (
          sb.payments.finance.payment_paid ? (
            <FinancePaid payment={sb.payments.finance} />
          ) : (
            <FinancePending sb={sb} payment={sb.payments.finance} />
          )
        ) : (
          record.leadContact?.vehicle?.vehicleDocumentation
            ?.outstandingFinance &&
          !sb.cancelled &&
          (!record.deposit ||
            record.leadContact.vehicle.vehicleSalvage.chequePayment ||
            (sb.payments.deposit && sb.payments.deposit.payment_paid)) &&
          (!record.leadContact.vehicle.vehicleCommercial ||
            !record.leadContact.vehicle.vehicleCommercial.commercialPurchase ||
            record.quoteRequestInvoices[0]) && <FinanceOutstanding sb={sb} />
        )}
      </Grid>
    </React.Fragment>
  )
}

FinancePayment.propTypes = {
  sb: PropTypes.object,
}

export default FinancePayment
